<div class="wallboardViewSlide" [attr.mid]="moduleKey" [ngStyle]="{ 'background-image': 'url(../Admin/ImageResizer.aspx?imgid=' + backgroundID + '&w=1920&h=1080)' }">
    <div class="wallboardSummarySlideContentArea" style="height:100vh; overflow:hidden">
        <div [ngClass]="{ 'summaryViewDark': hasBackdrop }" style="width:88%; padding:10px 30px; margin:1vh auto; overflow:hidden; text-shadow:2px 2px 8px #000000; border-radius:8px; box-sizing:content-box" *ngIf="hasPagination || summaryState?.SummaryTitle.trim() !== ''">
            <div class="col-xl-12 px-0 d-flex">
                <div class="font-size-32 px-0 txtOverflow col-xl-10">{{summaryState?.SummaryTitle}}</div>
                <div class="col-xl-2" *ngIf="totalPages < 0"></div>
                <div class="font-size-24 col-xl-2 px-0 pt-2 d-flex pageNumber justify-content-end" *ngIf="totalPages > 0">{{(currentPage + 1) + "/" + totalPages}}</div>
            </div>
        </div>

        <div id="TableArea" [ngClass]="getMainClasses()" style="width:88%; padding:10px 30px; margin:1vh auto; overflow:hidden; text-shadow:2px 2px 8px #000000; border-radius:8px; box-sizing:content-box">
            <!--<div style="width:25%; height:1px; display:inline-block"></div>-->
            <div class="d-flex justify-content-end summaryMetricHeaders" [ngClass]="isSmallScreen ? 'font-size-20' : 'font-size-24'">
                <div class="col-xl-2 pl-0 summaryName">Name</div>
                <div [ngClass]="'col-xl-' + getColumnWidth()" *ngIf="getColumnWidth() > 0"></div>
                <div class="summaryMetricName txtOverflowSummary col-xl-1 pr-0" [ngClass]="isSmallScreen ? 'font-size-20' : 'font-size-24'" *ngFor="let Name of summaryMetricNames?.slice(0,10); let $index = index">
                    <span #metricNameRefs>{{Name}}</span>
                </div>
            </div>

            <div class="row no-gutters">
                <div class="summaryTableRow col-xl-12" [ngClass]="isSmallScreen ? 'font-size-20' : 'font-size-24'">
                    <div [id]="'row' + $index" class="fullSlide border-bottom pb-1 d-flex"
                         *ngFor="let item of currentPageItems; let $index = index">
                        <div class="summaryGroupName txtOverflowSummary col-xl-2">
                            <div class="summaryRank" *ngIf="summaryState?.ShowRank && ((getGlobalRowIndex($index) + 1) < (summaryData?.Summary_Module_Data_List.length + 1) || !hasTotalsRow)">
                                {{getGlobalRowIndex($index) + 1}}
                            </div>

                            <span #groupNameRefs>{{item.groupName?.trim()}}</span>
                        </div>

                        <div [ngClass]="'col-xl-' + getColumnWidth()" *ngIf="getColumnWidth() > 0"></div>
                        <div class="summaryMetricData col-xl-1 pr-0" *ngFor="let data of item.metricData">{{data.MetricDisplayValue}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-end font-size-20" [ngClass]="{ 'summaryViewDark': hasBackdrop, 'font-size-24': !isSmallScreen }"
             style="width:88%; padding:10px 30px; margin:1vh auto; overflow:hidden; text-shadow:2px 2px 8px #000000; border-radius:8px; box-sizing:content-box" *ngIf="hasTotalsRow">
            <div class="col-xl-2 summaryTotalsName">{{totals.groupName}}</div>
            <div [ngClass]="'col-xl-' + getColumnWidth()" *ngIf="getColumnWidth() > 0"></div>
            <div class="col-xl-1 summaryMetricData pr-0" *ngFor="let data of totals.metricData">{{data?.MetricDisplayValue}}</div>
        </div>
    </div>
</div>
